import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopPaytm = dynamic(() => import("../../components/software-partners/PaytmMLoyal/DesktopPaytm"), {
    loading: () => <Loading />,
});

const MobilePaytm = dynamic(() => import("../../components/software-partners/PaytmMLoyal/MobilePaytm"), {
    loading: () => <Loading />,
});

const PaytmMLoyalIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QueueBuster POS with Paytm & mLoyal Integration | Boost Customer Engagement</title>
                <meta name="description" content="Integrate QueueBuster POS with Paytm and mLoyal to enhance customer loyalty and payment convenience. Streamline billing and rewards with this powerful combination." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/paytm-mLoyal" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/paytm-mLoyal" hrefLang="en-us" />
                <meta property="og:title" content="QueueBuster POS + Paytm & mLoyal: Seamless Payments and Loyalty Managemen" />
                <meta property="og:description" content="Discover the perfect blend of QueueBuster POS with Paytm and mLoyal integration. Simplify payments, boost customer loyalty, and manage rewards effortlessly." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/Group%2B1171276127.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/paytm-mLoyal" />
            </Head>
            {mobileView ? <MobilePaytm /> : <DesktopPaytm />}
        </>
    )
}

export default PaytmMLoyalIntegration;